module.exports = __webpack_public_path__ + "img/educacao_empreendedora_ouro.1dd14c5d.png";